import React from 'react';
import './VR.css';

const VR = () => {
    return ( 
        <>
        <iframe title="VR" src="https://www.3dvista.com/samples/real_estate_virtual_tour.html"></iframe>
        </>
     );
}
 
export default VR;